import React from 'react';
import CandidateProfilePopup from './CandidateProfilePopup';

function EmployerProfilePage({onClose, profileData}) {
  // Debug log removed — was dumping the full candidate profile (PII) to console
  // every time the popup mounted.

  // Transform profileData to match the expected candidate format
  const candidate = {
    name: profileData?.data?.firstName && profileData?.data?.lastName 
      ? `${profileData.data.firstName} ${profileData.data.lastName}` 
      : profileData?.data?.name || 'Unknown Candidate',
    email: profileData?.data?.email || '',
    phone: profileData?.data?.phone || '',
    job_title: profileData?.data?.title || profileData?.data?.job_title || 'Job Seeker',
    job_id: profileData?.data?.job_id || '',
    experience: profileData?.data?.experience || '',
    qualification: profileData?.data?.qualification || '',
    currentLocation: profileData?.data?.city || profileData?.data?.currentLocation || '',
    preferredLocation: profileData?.data?.preferredLocation || '',
    skills: profileData?.data?.skills || '',
    Resume_Score: profileData?.data?.Resume_Score || profileData?.data?.resume_score || '',
    created_at: profileData?.data?.created_at || profileData?.data?.application_date || '',
    resume_path: profileData?.data?.resume_path || '',
    // Add any other fields that might be available
    ...profileData?.data
  };

  return (
    <CandidateProfilePopup 
      candidate={candidate} 
      onClose={onClose} 
    />
  );
}

export default EmployerProfilePage;